
import {
  defineComponent,
  onMounted,
  PropType,
  reactive,
} from 'vue';
import Modal from '@/components/atoms/Modal.vue';
import FeaturesCheckBox from '@/components/atoms/FeaturesCheckBox.vue';
import ListElement from '@/components/atoms/ListElement.vue';
import useAmplitude from '@/composables/useAmplitude';
import { TimeOutContent } from '@/domain/services/types';

export default defineComponent({
  components: {
    ListElement,
    FeaturesCheckBox,
    Modal,
  },
  emits: ['activateStep3', 'cancel', 'exitSteps', 'timeOutPlanPurchase'],
  props: {
    content: {
      type: Object as PropType<TimeOutContent>,
      required: true,
    },
    canCancelSubscription: {
      type: Boolean,
      default: false,
    },
  },
  setup() {
    const showFeatures = reactive({
      featuresIncluded: true,
      featuresNotIncluded: false,
    });

    onMounted(() => {
      useAmplitude()?.logEvent('Timeout_plan_screen');
      (window as any)?.dataLayer.push({
        event: 'Timeout_plan_screen',
      });
    });

    function showAllFeatures() {
      showFeatures.featuresNotIncluded = !showFeatures.featuresNotIncluded;
      useAmplitude()?.logEvent('Timeout_plan_info');
      (window as any)?.dataLayer.push({
        event: 'Timeout_plan_info',
      });
    }

    return {
      showFeatures,
      showAllFeatures,
    };
  },
});
